import { Roles } from "../stores/authStore.ts";

const ROLE_TRANSLATION_KEYS = {
  [Roles.ROOT_ADMIN]: "roles.rootAdmin",
  [Roles.KINDERGARTEN_ADMIN]: "roles.kindergartenAdmin",
  [Roles.KINDERGARTEN_USER]: "roles.kindergartenUser",
  [Roles.DRIVER]: "roles.driver",
  [Roles.PARENT]: "roles.parent",
  [Roles.SALES_AGENT]: "roles.salesAgent",
  [Roles.ACCOUNTANT]: "roles.accountant",
  [Roles.TEACHER]: "roles.teacher",
};

export function getRoleTranslationKey(role) {
  return ROLE_TRANSLATION_KEYS[role] ?? null;
}

export function formatRoleLabel(role, t) {
  if (!role) return t("roles.user");
  const translationKey = getRoleTranslationKey(role);
  if (translationKey) {
    return t(translationKey);
  }
  return role.replace(/_/g, " ");
}

export function getRoleBadgeVariant(role) {
  switch (role) {
    case Roles.ROOT_ADMIN:
      return "danger";
    case Roles.KINDERGARTEN_ADMIN:
      return "warning";
    case Roles.DRIVER:
      return "info";
    case Roles.PARENT:
      return "success";
    case Roles.KINDERGARTEN_USER:
      return "gray";
    case Roles.SALES_AGENT:
      return "purple";
    case Roles.ACCOUNTANT:
      return "primary";
    case Roles.TEACHER:
      return "accent";
    default:
      return "gray";
  }
}

